<template functional>
  <v-toolbar-title class="ml-0 pl-3">
    <v-tooltip bottom class="hidden-xs-only" v-show="props.isPublished && !props.isScheduled && props.publicUrl">
      <v-btn icon slot="activator" :href="props.publicUrl" target="_blank">
        <v-icon class="nx-ui--level-1 nx-negative nx-schedule px-2">link</v-icon>
      </v-btn>
      <span>{{ parent.$t('message.common.publicUrl') }}</span>
    </v-tooltip>

    <v-tooltip bottom class="hidden-xs-only" v-show="props.isScheduled">
      <v-icon slot="activator" class="nx-ui--level-1 px-2 cursor-default" color="warning">alarm</v-icon>
      <span v-if=" props.scheduleDate">
        {{ parent.$t('message.metadata.scheduled') }} {{ props.scheduleDate|formatDate }}
      </span>
      <span v-else>{{ parent.$t('message.metadata.scheduled') }}</span>
    </v-tooltip>

    <span class="nx-title">{{ props.title }}</span>
  </v-toolbar-title>
</template>

<script>
export default {
  name: 'nx-content-editor-header-info',
  props: {
    isPublished: Boolean,
    isScheduled: Boolean,
    scheduleDate: String,
    url: String,
    title: String,
    publicUrl: String,
  },
};
</script>

<style lang="stylus" scoped>
  .nx-schedule {
    transform: rotate(45deg);
  }

  .nx-title {
    text-overflow: ellipsis;
  }
</style>
